import Home from './routes/home/Index.vue'
// import Crm from './routes/crm/Index.vue'
// import crmRoutes from './routes/crm/router'
import Administration from './routes/administration/Index.vue'
import administrationRoutes from './routes/administration/router'
import Opticheck from './routes/opticheck/Index.vue'
import opticheckRoutes from './routes/opticheck/router'
import User from './routes/user/Index.vue'
import userRoutes from './routes/user/router'
import AdWords from './routes/adwords/Index.vue'
import adwordsRoutes from './routes/adwords/router'

let appRoutes = [
  {
    path: 'home',
    name: 'home',
    component: Home,
  },
  // {
  //   path: 'crm',
  //   name: 'crm',
  //   component: Crm,
  //   children: crmRoutes,
  //   meta: { guard: 'CRM' },
  // },
  {
    path: 'user',
    name: 'user',
    component: User,
    children: userRoutes,
    meta: { guard: 'TODO' },
  },
  {
    path: 'administration',
    name: 'administration',
    component: Administration,
    children: administrationRoutes,
    meta: { guard: 'ADMIN' },
  },
  {
    path: 'opticheck',
    name: 'opticheck',
    component: Opticheck,
    children: opticheckRoutes,
    meta: { guard: 'OPTICHECK' },
  },
  {
    path: 'adwords',
    name: 'adwords',
    component: AdWords,
    children: adwordsRoutes,
    meta: { guard: 'ADWORD' },
  },
]

export default appRoutes
